"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _PagesSettingsHeader = _interopRequireDefault(require("../components/PagesSettingsHeader"));

var _selectors = require("settings-ui-sdk/Routes/selectors");

var _selectors2 = require("settings-ui-sdk/Auth/selectors");

var _selectors3 = require("settings-ui-sdk/Domains/selectors");

var _RequestStatusTypes = require("settings-ui-sdk/constants/RequestStatusTypes");

var _routeSelectors = require("../selectors/routeSelectors");

var _getAllDomainsOrDomainNameFromURL = _interopRequireDefault(require("../utils/getAllDomainsOrDomainNameFromURL"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var PagesSettingsHeaderContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PagesSettingsHeaderContainer, _Component);

  function PagesSettingsHeaderContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PagesSettingsHeaderContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PagesSettingsHeaderContainer).call(this, props));
    _this.handleSelectedTabChange = _this.handleSelectedTabChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSelectedDomainChange = _this.handleSelectedDomainChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(PagesSettingsHeaderContainer, [{
    key: "handleSelectedDomainChange",
    value: function handleSelectedDomainChange(evt) {
      var activeTab = this.props.activeTab;
      var domainId = evt.target.value;
      this.props.push(_UrlPathParams.WEBSITE + "/" + _UrlPathParams.PAGES + "/" + domainId + "/" + activeTab);
    }
  }, {
    key: "handleSelectedTabChange",
    value: function handleSelectedTabChange(evt) {
      var selectedDomain = this.props.selectedDomain;
      var tabId = evt.target.value;
      this.props.push(_UrlPathParams.WEBSITE + "/" + _UrlPathParams.PAGES + "/" + selectedDomain + "/" + tabId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeTab = _this$props.activeTab,
          domainOptions = _this$props.domainOptions,
          selectedDomain = _this$props.selectedDomain,
          isAllDomainsSelected = _this$props.isAllDomainsSelected,
          fetchDomainsRequestStatus = _this$props.fetchDomainsRequestStatus,
          hasTemplatesAccess = _this$props.hasTemplatesAccess,
          hasMarketplaceAccess = _this$props.hasMarketplaceAccess,
          hasSiteSettingsTemplatesAccess = _this$props.hasSiteSettingsTemplatesAccess;
      return _react.default.createElement(_PagesSettingsHeader.default, {
        activeTab: activeTab,
        domainOptions: domainOptions,
        onSelectedDomainChange: this.handleSelectedDomainChange,
        onSelectedTabChange: this.handleSelectedTabChange,
        selectedDomain: selectedDomain,
        isAllDomainsSelected: isAllDomainsSelected,
        domainsRequestStatus: fetchDomainsRequestStatus,
        hasSystemPagesAccess: hasTemplatesAccess || hasMarketplaceAccess,
        hasSiteSettingsTemplatesAccess: hasSiteSettingsTemplatesAccess
      });
    }
  }]);
  return PagesSettingsHeaderContainer;
}(_react.Component);

PagesSettingsHeaderContainer.propTypes = {
  activeTab: _react.PropTypes.string.isRequired,
  domainOptions: _react.PropTypes.array.isRequired,
  selectedDomain: _react.PropTypes.string.isRequired,
  push: _react.PropTypes.func.isRequired,
  isAllDomainsSelected: _react.PropTypes.bool.isRequired,
  fetchDomainsRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  hasTemplatesAccess: _react.PropTypes.bool.isRequired,
  hasMarketplaceAccess: _react.PropTypes.bool.isRequired,
  hasSiteSettingsTemplatesAccess: _react.PropTypes.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeTab: (0, _selectors.getActiveTabIdFromRoute)(state),
    domainOptions: (0, _selectors3.getDomainOptionsIncludingAllDomains)(state),
    selectedDomain: (0, _routeSelectors.getAllDomainsOrDomainNameFromRoute)(state),
    isAllDomainsSelected: (0, _getAllDomainsOrDomainNameFromURL.default)(window.location.href) === _UrlPathParams.ALL_DOMAINS,
    fetchDomainsRequestStatus: (0, _selectors3.getFetchDomainsRequestStatus)(state),
    hasTemplatesAccess: (0, _selectors2.getHasTemplatesAccess)(state),
    hasMarketplaceAccess: (0, _selectors2.getHasMarketplaceAccess)(state),
    hasSiteSettingsTemplatesAccess: (0, _selectors2.getHasSiteSettingsTemplatesAccess)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  push: _reactRouterRedux.push
})(PagesSettingsHeaderContainer);

exports.default = _default;
module.exports = exports.default;